<div id="myModal" class="login_me" role="dialog">
    <!-- <div class="modal-dialog"> -->
      <!-- Modal content-->
      <div class="modal-content">
        <button type="button" class="close close_modal"  style="outline: none;" data-dismiss="modal" (click)="dismiss()"><span aria-hidden="true">×</span></button>
        <div class="modal-header">
          <h4 class="modal-title">Welcome Back!</h4>
          <p>Enter your following fields to sign in</p>
        </div>
        <div class="modal-body">
              <form [formGroup]="userSignIn" (ngSubmit)="usersignin()">
                  <div class="row">
                  <div class="col-md-12">
                <div class="form-group">
                  <input type="email"
                  autocomplete="off"
                          class="form-control"
                          id="email"
                          formControlName="usersEmail"
                          placeholder="Email">
                          <ng-container *ngIf="submitted && userIn.usersEmail.errors">
                            <p class="error-message" *ngIf=" userIn.usersEmail.errors.required">
                                Email is required!
                            </p>
                            <p class="error-message" *ngIf=" userIn.usersEmail.errors.email">
                                Enter Valid Email.
                            </p>
                        </ng-container>
                </div>
                </div>
                <div class="col-md-12">
                <div class="form-group">
                  <input type="password"
                          class="form-control"
                          id="pwd"
                          formControlName="usersPassword"
                          placeholder="Password">
                          <ng-container *ngIf="submitted && userIn.usersPassword.errors">
                            <p class="error-message" *ngIf=" userIn.usersPassword.errors.required">
                                Password is required!
                            </p>
                            <p class="error-message" *ngIf=" userIn.usersPassword.errors.minlength">
                                Password should be minimum of 5 characters.
                            </p>
                        </ng-container>
                </div>
                </div>

                <div class="col-md-12">
                    <button type="submit" class="sign_in" style="outline: none;"> Sign In </button>
               </div>
                <!-- <div class="col-md-12">
                    <div class="checkbox">
                     <label> New MEmber?<a (click)="showSignUpModal()">Sign Up</a></label>
                    </div>
                </div> -->
               </div>
              </form>
        </div>
      </div>
    <!-- </div> -->
  </div>
